import { ClipboardPlus } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";
import { useTenantRuntime } from "../config/TenantRuntime";
import { FlowOverviewPage } from "./FlowOverviewPage";

export function AssistancePage({ funeralOnly = false }: { funeralOnly?: boolean }) {
  const { tenant } = useTenantRuntime();
  if (!funeralOnly && tenant.product.commercialProductCode === "EVA_FLOW")
    return <FlowOverviewPage />;
  return (
    <div className="page-stack">
      <Card
        title="Acionamento do benefício"
        description="Módulo mínimo de elegibilidade e autorização funerária."
        action={
          <Button>
            <ClipboardPlus size={16} /> Abrir solicitação
          </Button>
        }
      >
        <div className="empty-state">
          <strong>Nenhuma solicitação aberta no ambiente demo</strong>
          <p>
            O módulo registra pessoa coberta, carência, benefício acionado, autorização, prestador e
            conclusão. Estoque, frota e cerimonial ficam fora desta fase.
          </p>
          <Badge tone="info">PRONTO PARA CONECTAR</Badge>
        </div>
      </Card>
    </div>
  );
}
